import { PrismToastQueue, PrismWormhole } from '@mylighthouse/prism-ember';

<template>
  <div id="ember-basic-dropdown-wormhole"></div>
  <PrismWormhole />

  {{outlet}}

  <PrismToastQueue />
</template>
